// Public (non-secret) runtime configuration. REACT_APP_* values are embedded
// in the bundle, so never put secrets here.
export const API_URL = (process.env.REACT_APP_API_URL || 'http://localhost:4100').replace(
  /\/+$/,
  ''
);

export const PUBLIC_API_PATH = '/api/commerce/v1/public';

// Listing page sizes. The server's snapshots paginate the same way (24
// products / 12 articles per ?halaman=N, docs/PHASE4.md decision P2), so the
// React page shows exactly what the snapshot showed. The demo shop (19
// products, no snapshots) uses 12 so its category pages show the paging too.
export const CATEGORY_PAGE_SIZE = process.env.REACT_APP_DEMO_CATALOG === 'true' ? 12 : 24;
export const ARTICLE_PAGE_SIZE = 12;

// Policy / info pages. In Phase 1 these come from the shop's CMS; the slugs
// are the Indonesian defaults every shop starts with.
export const INFO_PAGES = [
  { slug: 'tentang-kami', titleKey: 'pages.about' },
  { slug: 'kontak', titleKey: 'pages.contact' },
  { slug: 'faq', titleKey: 'pages.faq' },
  { slug: 'pengiriman-pengembalian', titleKey: 'pages.shipping' },
  { slug: 'kebijakan-privasi', titleKey: 'pages.privacy' },
  { slug: 'syarat-ketentuan', titleKey: 'pages.terms' },
];

/**
 * The info pages to link to. `published` is the store profile's list of
 * published page slugs (GET /public/store `pages`); a draft page would be a
 * dead link. `null` (an older server, or no profile yet) keeps all of them.
 */
export const infoPagesFor = (published) =>
  Array.isArray(published) ? INFO_PAGES.filter((p) => published.includes(p.slug)) : INFO_PAGES;

export const POLICY_SLUGS = ['pengiriman-pengembalian', 'kebijakan-privasi', 'syarat-ketentuan'];
